import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router
import './StickyLogo.css';
import logo from '../assets/logo.png';

const StickyLogo = () => {
  return (
    <Link to="/">
      <div className="sticky-logo">
        <img src={logo} alt="Logo" />
      </div>
    </Link>
  );
};

export default StickyLogo;
